import React from 'react';

const MISSION_POINTS = ['Precision over volume', 'Identity over imitation', 'Longevity over hype'];

const BrandHeader = () => (
  <div className="mb-16 text-center">
    <div className="flex justify-center items-center gap-6 mb-8">
      <img
        src="/rhodium-logo.png"
        alt="Rhodium Records"
        className="logo-img h-28 w-28 md:h-36 md:w-36 object-contain"
        style={{ animation: 'pulse 3s ease-in-out infinite' }}
      />
    </div>
    <h2 className="text-5xl md:text-7xl font-black mb-6">
      <span className="logo-text">RHODIUM RECORDS</span>
    </h2>
    <p className="text-silver-400 text-2xl md:text-3xl font-light italic mb-8">
      Rare by nature, relentless by design
    </p>
  </div>
);

const ManifestoCard = () => (
  <div className="max-w-4xl mx-auto mb-16">
    <div className="bg-gradient-to-br from-silver-900/30 to-silver-900/10 border-2 border-silver-400/30 rounded-2xl p-8 md:p-12">
      <div className="prose prose-invert prose-lg max-w-none">
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          Rhodium isn't just a name. It's a statement.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          Rhodium is one of the rarest and most valuable elements on Earth. It doesn't tarnish. It doesn't corrode. It reflects light at an almost unreal intensity. In a world full of noise, rhodium cuts through and shines harder than anything around it.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          That's the energy behind <strong className="text-silver-400 font-bold">Rhodium Records</strong>.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          We're not here for disposable tracks or microwave careers. We're built for artists who hit different, who don't fade, who don't dilute. The ones who walk into a room and bend the atmosphere without asking permission.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          At Rhodium Records, music isn't churned out. It's engineered to last. Every record is polished, elevated, and amplified until it reflects at full brilliance. No dull edges. No watered-down identity. Just pure, high-impact sound that sticks.
        </p>
      </div>
    </div>
  </div>
);

const MissionSection = () => (
  <div className="max-w-3xl mx-auto mb-16">
    <h3 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center">
      We move with <span className="text-silver-400">intention</span>:
    </h3>
    <div className="space-y-4">
      {MISSION_POINTS.map((point) => (
        <div
          key={point}
          className="bg-silver-900/10 border border-silver-900/20 hover:border-silver-400/30 rounded-xl p-6 transition-all duration-300 hover:transform hover:scale-105"
        >
          <div className="flex items-center gap-4">
            <div className="w-2 h-2 rounded-full bg-silver-400 flex-shrink-0" />
            <p className="text-white/90 text-lg font-medium">{point}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const ClosingCard = () => (
  <div className="max-w-4xl mx-auto mb-16">
    <div className="bg-gradient-to-r from-silver-900/20 to-transparent border border-silver-400/20 rounded-2xl p-8 md:p-12">
      <div className="prose prose-invert prose-lg max-w-none">
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          If you're chasing trends, keep scrolling.<br />
          If you're building something timeless, you're in the right place.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          This is for artists who see themselves as rare.<br />
          Who treat their sound like a signature, not a template.<br />
          Who want a label that sharpens their edge instead of sanding it down.
        </p>
        <p className="text-white/90 text-lg leading-relaxed">
          <strong className="text-silver-400 font-bold">Rhodium Records</strong> — rare by nature, relentless by design.
        </p>
        <p className="text-white/90 text-lg leading-relaxed mt-6">
          You bring the element. We make it shine.
        </p>
      </div>
    </div>
  </div>
);

export const AboutSection = () => (
  <section className="pt-32 pb-20 px-6" data-testid="about-section">
    <div className="container mx-auto">
      <BrandHeader />
      <ManifestoCard />
      <MissionSection />
      <ClosingCard />
    </div>
  </section>
);
